import React from 'react';

class Zoho extends React.PureComponent {
	render() {
		if (this.props.active) {
			return (
				<div width="100%">
					<iframe sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
						style={{ position: 'fixed', left: '0px', top: '0px', backgroundColor: '#FFF', width: '100%', height: '100%' }}
						src="https://hrtrpt.dirad.com/" />
				</div>
			)
		} else {
			return (
				<div width="100%">

				</div>
			)
		}
	}
}

const icon = "menuList"
const roles = ["View"]
export { Zoho, icon, roles }



// WEBPACK FOOTER //
// ./src/Views/Zoho.js